<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row :gutter="20" class="h-full">
      <el-col :span="5" class="h-full">
        <div class="border-1 border-solid h-full p-20px">
          <div class="font-bold">来源系统</div>
          <div class="flex mt-10px">
            <el-input v-model="sourceKeyword" clearable></el-input>
            <el-button type="primary" @click="searchSourceData" class="ml-10px">搜索</el-button>
          </div>
          <div class="mt-20px h-[calc(100%-90px)] overflow-auto" v-loading="sourceLoading">
            <div
              v-for="(value, key, index) in sourceData"
              :key="index"
              class="mb-10px truncate pl-10px pr-10px"
              @click="clickSourceOne(key)"
              :class="currentSource === key ? '!bg-[#f2f6fc]' : ''"
            >
              {{ key }}({{ value }})
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="19" class="h-full">
        <div class="h-full">
          <div class="flex">
            <el-input
              v-model="tableKeyword"
              clearable
              class="w-200px mr-10px"
              placeholder="请输入代码或名称"
            ></el-input>
            <el-upload
              id="fileDemo"
              action="#"
              :show-file-list="false"
              :before-upload="handleImportExcel"
            >
              <el-button type="primary" @click="searchTableData">搜索</el-button>
            </el-upload>
            <el-button type="primary" @click="resetTableData">重置</el-button>
          </div>
          <div class="mt-20px h-[calc(100%-56px)]">
            <div class="w-full h-[calc(100%-46px)] overflow-auto" v-loading="tableLoading">
              <el-col
                class="!w-188px h-212px mr-20px mb-20px"
                v-for="(item, index) in tableData"
                :key="index"
              >
                <div class="w-full h-full" @click="toDetail(item)">
                  <el-card
                    class="h-[calc(100%-34px)] relative"
                    :body-style="{ padding: '10px', height: '100%' }"
                  >
                    <div
                      class="absolute top-2/5 left-1/2 w-80px h-80px"
                      style="transform: translate(-50%, -50%)"
                    >
                      <img src="../../assets/images/table-blue.png" class="w-full h-full" alt />
                    </div>
                    <el-tooltip :content="`数据总数:${item.collectNumber}条`">
                      <div
                        class="w-[calc(100%-20px)] h-24px text-center absolute truncate"
                        style="bottom: 16%"
                      >
                        数据总数:{{ item.collectNumber }}条
                      </div>
                    </el-tooltip>
                  </el-card>
                  <el-tooltip :content="`${item.destTableName}(${item.destTableCode})`">
                    <div class="mt-10px text-center truncate">
                      {{ item.destTableName }}({{ item.destTableCode }})
                    </div>
                  </el-tooltip>
                </div>
              </el-col>
            </div>
            <div class="mt-20px">
              <el-pagination
                background
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page.sync="page.pageNo"
                :page-size="page.pageSize"
                :page-sizes="$pageSizeAll"
                layout="->, total, sizes, prev, pager, next"
                :total="page.total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import StickerSourceManagementService from '@/services/StickerSourceManagementService'

export default {
  name: 'stickerSourceManagement',
  data() {
    return {
      sourceKeyword: '',
      sourceLoading: false,
      tableKeyword: '',
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      sourceData: {},
      tableData: [],
      currentSource: '',
    }
  },
  methods: {
    async searchSourceData() {
      this.sourceLoading = true
      const res = await StickerSourceManagementService.getSourceSystems({
        filter: this.sourceKeyword,
      })
      this.sourceLoading = false
      if (res && res.code === 0) {
        this.sourceData = res.data
        if (!_.isEmpty(this.sourceData)) {
          const keyList = Object.keys(this.sourceData)
          this.currentSource = keyList[0]
          this.searchTableData()
        }
      }
    },
    handleImportExcel(file) {
      this.excelIo = new GC.Spread.Excel.IO()
      this.excelIo.open(file, (json) => {
        console.log(json, 'jsonnnn')
      })
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await StickerSourceManagementService.getSourceTables({
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        filter: this.tableKeyword,
        dataSourceName: this.currentSource,
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    resetTableData() {
      this.tableKeyword = ''
      this.searchTableData()
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    clickSourceOne(item) {
      this.currentSource = item
      this.searchTableData()
    },
    toDetail(item) {
      this.$router.push({
        path: './detail',
        query: {
          name: `${item.destTableName}(${item.destTableCode})`,
          id: item.id,
          destTableCode: item.destTableCode,
        },
      })
    },
  },
  created() {
    this.searchSourceData()
  },
}
</script>
